import React from 'react';
import '../../styles/components/AsperaNestedNavigation.scss';
import { withRouter } from 'react-router-dom';
import { SideNav, SideNavItems, SideNavMenu, Select, SelectItemGroup, SelectItem, SideNavMenuItem } from '../Carbon';
/**
 * React Component
 *
 * The AsperaNestedNavigation renders the navigation via a simple array
 *
 * @example
 * ```javascript
 * <AsperaNestedNavigation items={this.nav} />
 * ```
 */
export const AsperaNestedNavigation = withRouter(class AsperaNestedNavigation extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: true,
        };
        this.selectModel = { selected: '' };
        this.findValueById = (id) => {
            const { items } = this.props;
            let foundItem;
            let foundActive;
            const checkItems = (checkingItems) => {
                checkingItems.forEach(item => {
                    if (item.id === id)
                        foundItem = item;
                    if (item.active)
                        foundActive = item;
                    if (item.children)
                        checkItems(item.children);
                });
            };
            checkItems(items);
            return id ? foundItem : foundActive;
        };
    }
    componentDidMount() {
        const activeItem = this.findValueById();
        if (activeItem)
            this.selectModel.selected = activeItem.id;
        this.setState({ loading: false });
    }
    render() {
        const { className, initialActiveId, navigationTitle, items } = this.props;
        const { loading } = this.state;
        return loading ? null : (React.createElement("div", { className: `aspera-nested-navigation ${className ? className : ''}` },
            React.createElement("div", { className: "desktop-mode" },
                React.createElement(SideNav, { "aria-label": navigationTitle, expanded: true },
                    React.createElement(SideNavItems, null, items.filter(item => !item.hidden).map((item, index) => {
                        return (React.createElement(SideNavMenu, { key: index, title: item.name, defaultExpanded: initialActiveId === item.id, "data-auto": `aspera-nested-navigation--${item.id}` }, !!item.children && item.children.filter(item => !item.hidden).map((child, childIndex) => {
                            return (React.createElement(SideNavMenuItem, { key: `${index}-${childIndex}`, isActive: child.active, "data-auto": `aspera-nested-navigation--item-${child.id}`, onClick: (event) => {
                                    event.preventDefault();
                                    if (child.onClick)
                                        child.onClick(child);
                                } }, child.name));
                        })));
                    })))),
            React.createElement("div", { className: "mobile-mode" },
                React.createElement(Select, { id: "mobile-email-template-choice", value: this.selectModel.selected, labelText: navigationTitle, onChange: (event) => {
                        const foundValue = this.findValueById(event.target.value);
                        if (foundValue && foundValue.onClick)
                            foundValue.onClick(foundValue);
                    } }, items.filter(item => !item.hidden).map((item, index) => {
                    return (React.createElement(SelectItemGroup, { key: index, label: item.name, "data-auto": `aspera-nested-navigation--mobile--${item.id}` }, !!item.children && item.children.filter(item => !item.hidden).map((child, childIndex) => {
                        return (React.createElement(SelectItem, { key: `${index}-${childIndex}`, text: child.name, value: child.id, "data-auto": `aspera-nested-navigation--mobile--item-${child.id}` }, child.name));
                    })));
                })))));
    }
});
